import { render } from "./index.vue?vue&type=template&id=37dfd6fc&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=37dfd6fc&scoped=true&lang=less"
import "@/style/login-bg.less?vue&type=style&index=1&id=37dfd6fc&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dfd6fc"],['__file',"src/views/login/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37dfd6fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37dfd6fc', __exports__)) {
    console.log('reload')
    api.reload('37dfd6fc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=37dfd6fc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('37dfd6fc', render)
  })

}


export default __exports__